// @flow
/**
 * Course
 * -----
 * Takes an ID for one course,
 * Lists all the Module titles
 * And lessons and tests within
 */
import React from 'react';
import type {Node} from 'react';
import Page from '../../containers/page/page.js';
import {
  CourseResource,
  CoursePresentation,
  CourseModulesPresentation,
  CourseAssessment,
  CourseHeader,
} from './CoursePresentation.js';
import CourseCertificate from './CourseCertificate';
import type {
  ResourcesType,
  ModuleStatusesType,
  CoursesStatusesType,
  AssessmentStatusesType,
  ReduxStatusType,
} from '../../types.js';
import style from './Course.module.css';
import translate from '../../config/text';
import styles from "../Header/Header.module.css";
import {Link} from "react-router-dom";
import formStyle from '../../styles/form.module.css';
import {getFromLocalStorage} from "../../utility/utility";
import {LOGIN} from "../../redux/actions/action-types";
import axios from 'axios';
import { mailChimp } from '../../utility/apiVar'

// a flag for endpoint (manual so far)
// master branch must always have value false !!
const staging = false;
let segmentId;

// function read_base64_json(varName) {
//   try {
//     return JSON.parse(new Buffer(process.env[varName], 'base64').toString());
//   } catch (err) {
//     throw new Error(`no ${varName} environment variable`);
//   }
// };
//
// // A simple variable.
// let projectId = process.env.PLATFORM_PROJECT;
// console.log(projectId)
//
// // A JSON-encoded value.
// let variables = read_base64_json('PLATFORM_VARIABLES');
// console.log(variables)
//
// // const API_KEY = process.env.REACT_APP_API_KEY;
// //
// // console.log(API_KEY)
//
//


const testCourseComplete = (
  courseId: string,
  modules: Array<{
    target_id: string,
  }>,
  moduleStatuses: ModuleStatusesType,
  assessmentStatuses: AssessmentStatusesType
): boolean => {
  // all courses module complete
  // AND assessment complete
  return modules.every((
    module: {target_id: string}
  ): boolean => {
    return moduleStatuses[module.target_id];
  })
    && assessmentStatuses[courseId]
    ? true : false;
};

type CalcType = {complete: number, total: number};

const calculateCourseCompletetion = (
  courseId: string,
  courseModules: Array<{
    target_id: string,
  }>,
  moduleStatuses: ModuleStatusesType,
  assessmentStatuses: AssessmentStatusesType
): CalcType => {
  return courseModules.reduce((
    acc: {complete: number, total: number},
    module: {target_id: string}
  ): CalcType => {
    let {total, complete} = acc;

    return {
      total: ++total,
      complete: moduleStatuses[module.target_id] ? ++complete : complete,
    };
  }, {
      total: 1,
      complete: assessmentStatuses[courseId] ? 1 : 0,
    });
};


type CourseType = {
  resources: {
    data: ResourcesType,
    loaded: boolean,
  },
  route: {
    match: {
      params: {
        courseId: string,
      },
    },
  },
  moduleStatuses: ModuleStatusesType,
  coursesStatuses: CoursesStatusesType,
  assessmentStatuses: AssessmentStatusesType,
  updateCourseStatus: (string, string) => void,
  status: ReduxStatusType,
};

export const Course = ({
  resources,
  route,
  moduleStatuses,
  coursesStatuses,
  updateCourseStatus,
  assessmentStatuses,
  status,
  email,
}: CourseType): Node => {
  if (!resources.loaded) {
    return <div>Loading Course...</div>;
  }
  const t = translate(status.language);
  const courseId = route.match.params.courseId;
  const courseResource = resources.data.courses[courseId].resources;
  const courseData = resources.data.courses[courseId];
  const courseDone = testCourseComplete(
    courseId,
    courseData.field_modules,
    moduleStatuses,
    assessmentStatuses
  );


  const courseProgress = calculateCourseCompletetion(
    courseId,
    courseData.field_modules,
    moduleStatuses,
    assessmentStatuses
  );

  const userId = getFromLocalStorage(LOGIN.SUCCESS);
  const ts = Math.round((new Date()).getTime() / 1000);

  let courseTimestampStarted = {
    courseID: courseId,
    userId: userId,
    started: ts
  }

  courseTimestampRequest(courseTimestampStarted).then((res: boolean): void => {});

  const courseTitle = courseData.title[0].value;

  const newSegment = () => {
    let data = {
      name: courseTitle,
      static_segment: []
    }

    axios({
      method: 'POST',
      url: `https://cors-anywhere.herokuapp.com/https://us8.api.mailchimp.com/3.0/lists/${mailChimp.listId}/segments`,
      auth: {
        password: mailChimp.pass
      },
      data: JSON.stringify(data)
    });

    console.log('new segment created')
  }


  const config = {
    method: 'GET',
    url: `https://cors-anywhere.herokuapp.com/https://us8.api.mailchimp.com/3.0/lists/${mailChimp.listId}/segments`,
    responseType: 'json',
    headers: {
      'Access-Control-Allow-Origin': 'learn.cambridgeaudio.com',
      'Content-Type': 'application/json',
    },
    auth: {
      password: mailChimp.pass
    }
  }



  axios(config)
      .then(function (response) {
        const segments = response.data.segments;
        segmentId = segments.filter(segment => segment.name === courseTitle)

        if(!segments.some(segment => segment.name === courseTitle)){
          newSegment();
        }

        if (courseDone && coursesStatuses[courseId] === 'COMPLETED'){
          let data = {
            email_address: email,
          }

          axios({
            method: 'POST',
            url: `https://cors-anywhere.herokuapp.com/https://us8.api.mailchimp.com/3.0/lists/${mailChimp.listId}/segments/${segmentId[0].id}/members`,
            auth: {
              password: mailChimp.pass
            },
            data: JSON.stringify(data)
          });
          console.log('completed added')

        }
      });



  if (!courseData) {
    return <div>Can not find course [invalid course ID]</div>;
  }
  // TODO: Remove the onClick from Courses?
  if (
    coursesStatuses[courseId] === 'NOT_STARTED'
    || !coursesStatuses[courseId]
  ) {
    updateCourseStatus('STARTED', courseId);
  }
  if (courseDone && coursesStatuses[courseId] !== 'COMPLETED') {
    updateCourseStatus('COMPLETED', courseId);
  }
  if (courseDone && coursesStatuses[courseId] === 'COMPLETED') {


    const userId = getFromLocalStorage(LOGIN.SUCCESS);
    const ts = Math.round((new Date()).getTime() / 1000);

    let courseTimestampCompleted = {
      courseID: courseId,
      userId: userId,
      completed: ts
    }

    courseTimestampRequest(courseTimestampCompleted).then((res: boolean): void => {});
  }
  return (
    <Page>
      <CourseHeader
        title={courseData.title[0].value}
        progress={courseProgress} />
      <div className={style.page}>
        <div className={style.content}>
          <h4 className={`${style.subHeaderPlus} fontTisa`}>{t('course')}s</h4>
          <CourseModulesPresentation
            courseData={courseData}
            resources={resources.data}
            moduleStatuses={moduleStatuses} />
          <CourseAssessment
            courseId={courseId}
            completed={assessmentStatuses[courseId]}
            courseTitle={courseData.title[0].value}
            email={status.email}
            firstName={status.firstName}
            lastName={status.lastName}
            // language={status.language}
            country={status.country}
            company={status.company}
            t={t} />
            {
                courseResource
                    ?
                    <CourseResource
                        data={courseResource}
                        t={t} />
                    : null
            }
            <div className={style.certificate}>
                {
                    courseProgress.total === courseProgress.complete
                        ? <CourseCertificate
                            courseProgress={courseProgress}
                            t={t}
                            email={status.email}
                            courseId={courseId}
                            firstName={status.firstName}
                            lastName={status.lastName}
                            language={status.language}
                            country={status.country}
                            company={status.company} />
                        : null
                }
            </div>
        </div>
        <CoursePresentation t={t} courseDone={courseDone} {...courseData} />
      </div>
      <div className={styles.returnButton}>
          <Link to="/courses" className={formStyle.buttonBcg}>
              {t('return')}
          </Link>
      </div>
    </Page>
  );
};


type CourseTimestampRequestType = {
  courseID: string,
  userId: string,
  completed: string,
  started: string,
};

const courseTimestampRequest = ({
      courseID,
      userId,
      completed,
      started,
    }: CourseTimestampRequestType): * => {
  const body = {
    courseID: courseID,
    userId: userId,
    completed: completed,
    started: started,
  };



  const url = `https://${staging === true ? 'staging' : 'www' }.cambridgeaudio.com/gbr/en/api/learning/course/timestamps/check`;
  return req(url, body).then((res: any): boolean => {
      if(res.status === 200) {
          req(`https://${staging === true ? 'staging' : 'www' }.cambridgeaudio.com/gbr/en/api/learning/course/timestamps/check`,body).then((res: any): boolean => {
              return true;
          });
      }
      return false;
  }).catch((err: any): boolean =>  {
      return false;
  });
};

type BodyType = {
  courseID: string,
  userId: string,
  completed: string,
  started: string,
};


const req = (url: string, body: BodyType): * => fetch(url, {
  body: JSON.stringify(body),
  cache: 'no-cache',
  method: 'POST',
  mode: 'cors',
  headers: {
    'content-type': 'application/json',
  },
});


// WEBPACK FOOTER //
// ./src/components/Course/Course.js